import React, {useEffect, useState} from 'react';
import { FormattedMessage } from 'react-intl';
import OTButton from "./OTButton";
import {getTime} from "../../utils/TimeUtils";
import {SESSION} from "../../data/reducer";
import { connect } from "react-redux";
import {getFrontendProperties} from "../../definitions/Config";

const SessionToast = (props) => {
  const {
    sessionToast,
    continueSession,
    sessionAlertActive,
  } = props;

  const MINUTES = 60000;
  const [sessionTimeLeft, setSessionTimeLeft] = useState(getFrontendProperties().inactivityLogoutTime - getFrontendProperties().inactivityWarnTime)

  useEffect(() => {
    //counter for showing remaining session time
    const interval = setInterval(() => setSessionTimeLeft(sessionTimeLeft => sessionTimeLeft - 1), MINUTES);
    return () => clearInterval(interval);
  }, [sessionAlertActive])

  return <>
    <FormattedMessage
        id={`session.toast`}
        values={{br: <br />}}/>
    <OTButton onClick={() => continueSession(sessionToast)}>
      <FormattedMessage id={`session.continue`}>
        {txt => txt}
      </FormattedMessage>
    </OTButton>
  </>
}

const mapStateToProps = (state) => {
  return {
    sessionAlertActive: state[SESSION].sessionAlertActive,
  };
};

export default connect(mapStateToProps)(SessionToast);